import { useSelector, useDispatch } from "react-redux";
import * as React from "react";

import { Typography } from "mpulse-design-system";
import { Box, Grid } from "@mui/material";

import { API_V1_GET_AUDIO_FILE_INFO_REQUEST } from "../../redux/audioFile/actionTypes";
import { API_V1_GET_METADATA_INFO_REQUEST } from "../../redux/metadata/actionTypes";
import { API_V1_GET_CLIENTS_REQUEST } from "../../redux/client/actionTypes";
import { useAuth } from "../../hooks/useAuth";
import { getToday } from "../../utils/utils";

import LoginContainer from "../../components/LoginContainer/LoginContainer";
import AccountCard from "../../components/AccountCard/AccountCard";
import LoadingData from "../../components/LoadingData/LoadingData";
import InfoCard from "../../components/InfoCard/InfoCard";

const Dashboard = () => {
  const { client, accounts, metadata, audioFile } = useSelector(
    (state) => state
  );
  const dispatch = useDispatch();
  const isLoggedIn = useAuth().isLoggedIn.current;
  const clientId = client.id;
  const accountIds = Object.keys(client.accountsMap);
  const fetchMetadata = metadata.fetchData;

  const showLoadingPage = Boolean(!accounts[0].id);
  let AccountCards = [];

  // Make sure we have at least 1 account
  if (accounts[0].id) {
    accounts.forEach((account) => {
      AccountCards.push(
        <Grid item lg={4} md={6} sm={12} key={account.id}>
          <AccountCard
            key={account.id}
            account={account}
            accountMetadata={metadata[account.id]}
            accountAudio={audioFile[account.id]}
            fetchingMetadataInfo={metadata.fetchData}
            fetchingAudioFileInfo={audioFile.fetchData}
          />
        </Grid>
      );
    });
  }

  React.useEffect(() => {
    if (isLoggedIn) {
      if (!clientId) {
        dispatch({ type: API_V1_GET_CLIENTS_REQUEST });
      }

      dispatch({
        type: API_V1_GET_METADATA_INFO_REQUEST,
        accountIds: accountIds,
      });

      dispatch({
        type: API_V1_GET_AUDIO_FILE_INFO_REQUEST,
        accountIds: accountIds,
      });
    }
  }, [isLoggedIn]);

  return showLoadingPage ? (
    <LoginContainer>
      <LoadingData />
    </LoginContainer>
  ) : (
    <Box sx={{ margin: (theme) => `${theme.spacing(5)} ${theme.spacing(3)}` }}>
      <Grid container rowSpacing={10} columnSpacing={3}>
        <Grid item md={6} lg={5}>
          <Typography
            variant="h1"
            color="textPrimary"
            sx={{ marginBottom: (theme) => theme.spacing(3) }}
          >
            Welcome to the Audio Dashboard!
          </Typography>
          <Typography variant="subtitle1" color="textPrimary">
            Today is {getToday()}
          </Typography>
        </Grid>
        <Grid container item md={6} lg={7} spacing={3} justifyContent="flex-end">
          <Grid item xs={12} lg={4} justifyContent="flex-end">
            <InfoCard
              title={audioFile.fetchData ? null : audioFile.metadataCreatedThisYear.label}
              count={
                audioFile.fetchData ? null : audioFile.metadataCreatedThisYear.total
              }
            />
          </Grid>
          <Grid item xs={12} lg={4} justifyContent="flex-end">
            <InfoCard
              title={"Audio Ready for Review"}
              count={audioFile.fetchData ? null : audioFile.totalReadyForReview}
            />
          </Grid>
          <Grid item xs={12} lg={4} justifyContent="flex-end">
            <InfoCard
              title={"Waiting for Voice Talent"}
              count={
                audioFile.fetchData ? null : audioFile.totalReadyForRecording
              }
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h2" color="textPrimary">
                {client.accountLabel}s
              </Typography>
            </Grid>
            <Grid container item xs={12} spacing={3}>
              {AccountCards}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
